import { apiInterceptor } from "./interceptors/jwt.interceptor";

export const getFormsFromServiceLineName = async (serviceLineName) => {
  try {
    const response = await apiInterceptor({
      method: "GET",
      endpoint: `/tr/admin/forms?service_line=${serviceLineName}`,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};
